// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"131":"intro","178":"notfound","541":"dev_portfolio","962":"store"}[chunkId] + "." + {"131":"6e4a1274","178":"906b5fa8","541":"8db5a084","962":"668efe8d"}[chunkId] + ".css";
};